"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
'kiwi public'; // eslint-plugin-vue's max-len rule reads the entire file, including the CSS. so we can't use this
// here as some of the rules cannot be broken up any smaller

/* eslint-disable max-len */

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _MediaViewer = _interopRequireDefault(require("./MediaViewer"));

var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));

var _MessageInfo = _interopRequireDefault(require("./MessageInfo"));

var methods = {
  props: {},
  getNetwork: function getNetwork() {
    var props = this.props;
    return props.ml.buffer.getNetwork();
  },
  isRepeat: function isRepeat() {
    var props = this.props;
    var ml = props.ml;
    var idx = props.idx;
    var message = props.message;
    var prevMessage = ml.filteredMessages[idx - 1];
    return !!prevMessage && prevMessage.nick === message.nick && message.time - prevMessage.time < 60000 && prevMessage.type !== 'traffic' && message.type !== 'traffic' && message.type === prevMessage.type;
  },
  isHoveringOverMessage: function isHoveringOverMessage(message) {
    var props = this.props;
    return message.nick && message.nick.toLowerCase() === props.hover_nick.toLowerCase();
  },
  userMode: function userMode(user) {
    var props = this.props;
    return props.ml.buffer.userMode(user);
  },
  userModePrefix: function userModePrefix(user) {
    var props = this.props;
    return props.ml.buffer.userModePrefix(user);
  }
};
var _default = {
  inject: {
    components: {
      default: {
        AwayStatusIndicator: _AwayStatusIndicator.default,
        MessageInfo: _MessageInfo.default,
        MediaViewer: _MediaViewer.default
      }
    }
  },
  props: {
    ml: Object,
    message: Object,
    idx: Number,
    m: {
      default: function m() {
        // vue uses this function to generate the prop. `this`==null Return our own function
        return function n() {
          // Give our methods some props context before its function is called.
          // This is only safe because the function on the methods object is called on
          // the same js tick
          methods.props = this;
          return methods;
        };
      }
    }
  }
};
exports.default = _default;
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["MessageListMessageCompact"]
window._kiwi_exports.components.MessageListMessageCompact = exports.default ? exports.default : exports;
